module.exports = __webpack_public_path__ + "static/img/ic-qrcode.a062c1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/ic-qrcode.png
// module id = 1yX3
// module chunks = 1